import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://atlasregistry-api-dev.mosten.io/api',
  products: {
    atlasHealth: 'https://atlashealth-portal-dev.mosten.io',
    atlasEnergy: 'https://atlasenergy-portal-dev.mosten.io',
    atlasAssist: 'https://atlasassist-portal-dev.mosten.io'
  },
  checkProductAvailability: false
};
